import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=6c2de55d&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=6c2de55d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2de55d",
  null
  
)

export default component.exports